import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "optionsBox" }
const _hoisted_2 = { class: "title" }
const _hoisted_3 = ["innerHTML"]
const _hoisted_4 = /*#__PURE__*/_createElementVNode("div", { class: "operation" }, null, -1)
const _hoisted_5 = /*#__PURE__*/_createElementVNode("div", { class: "btns" }, null, -1)

import data from "@/data/data";
import log from "@/data/log";

export default /*#__PURE__*/_defineComponent({
  __name: 'about',
  setup(__props) {


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("p", _hoisted_2, _toDisplayString(_unref(data).about.name), 1),
      _createElementVNode("p", {
        class: "about",
        innerHTML: _unref(data).about.context
      }, null, 8, _hoisted_3),
      _hoisted_4,
      _hoisted_5
    ])
  ]))
}
}

})